import React from "react";
import CreateVulscanScheduleCard from "./VulscanScheduleCard";

function VulscanScheduleCardModal({ handleClose, cardType }) {

    return (
        <div className="modal oct_display-block">
            <div className="create-user-modal">

                <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                </button>

                <div className="create-nmap-box">
                    <CreateVulscanScheduleCard handleClose={handleClose} cardType={cardType} />
                </div>
            </div>
        </div>
    )

}


export default VulscanScheduleCardModal;